import React from 'react';
import css from './StockItem.css';
import { ConditionalWrapper } from '../../../../util/common';
import { CroppText } from '../../../../util/text';
import { useTextCrop } from '../../../../hooks/useTextCrop';

const withImgixSharpness = url => {
    if (!url) return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}dpr=2&auto=format&q=80&fit=crop&w=564&h=376`;
};

export default ({ inStock, total, logo, title, description, isMobile }) => {
    const threeLinesHeight = 72;

    const { showCropped, contentRef, setContentRef, setShowCropped } = useTextCrop({
        threeLinesHeight,
    });
    const showCroppedParagraph = isMobile && showCropped;
    return (
        <div className={css.container}>
            <div
                className={css.logoHolder}
                style={
                    logo
                        ? {
                              backgroundImage: `url(${withImgixSharpness(logo)})`,
                          }
                        : {}
                }
            />
            <div className={css.content}>
                <div className={css.progressBar}>
                    <div
                        style={{
                            width: `${(inStock * 100) / total}%`,
                            transition: '1s',
                        }}
                    />
                </div>
                <p className={css.inStockInfo}>
                    {!inStock || inStock < 1 ? (
                        <span>
                            <b>Gewinn vollständig vergeben</b>
                        </span>
                    ) : (
                        <span>
                            <b>Noch {inStock}</b> von {total} Stück zu gewinnen
                        </span>
                    )}
                </p>
                <h3>{title}</h3>

                <ConditionalWrapper
                    condition={showCroppedParagraph}
                    wrapper={children => (
                        <CroppText
                            maxHeight={threeLinesHeight}
                            componentRef={contentRef ? { current: contentRef } : null}
                        >
                            {children}
                        </CroppText>
                    )}
                >
                    <p ref={setContentRef}>{description}</p>
                </ConditionalWrapper>
                {showCroppedParagraph && (
                    <p className={css.toggler} onClick={() => setShowCropped(false)}>
                        Mehr anzeigen
                    </p>
                )}
            </div>
        </div>
    );
};
